/* global */

import { controller, controllerAs, template } from 'modals/marketplaceRegister';
import { clone, get } from 'lodash';

export default function(
  $log,
  $uibModal,
  $state,
  $scope,
  $window,
  ProfileClass,
  EventClass,
  CoursesClass,
  ApiClass,
  $uibModalStack,
  $location,
  AuthClass,
  Swal,
  VendorClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const loggedIn = ProfileClass.loggedIn;
  const profile_uid = ProfileClass.profile_uid;

  $scope.disableButton = get(ProfileClass, 'profileComplete.company.preferences.read_only.user.launchLatestActivity');

  vm.eventAction = function(actionType) {
    const event = vm.event || {};
    const { status, type, registration_id, price } = event;
    const vendor_id = get(event, 'vendor.vendor_id', event.vendor_id);

    if (event.link) {
      return openLink();
    }

    if (actionType !== 'pass' && status === 'bundlePurchase') {
      return event.url ? ($window.location = event.url) : $state.go('app.bundles');
    }

    if (!loggedIn) {
      return AuthClass.authenticationPopup({ company_id: VendorClass.convertUser(vendor_id) }); //open login for not logged in users;
    }

    if (vm.adminRegistration) {
      return register(); // open register modal for admin registrations
    }

    if (EventClass.isEvent(event) && registration_id) {
      return launchScorm();
    }

    if (status === 'registered' || status === 'userRegistered') {
      return price ? $log.debug('Purchased Course') : vm.unRegister();
    }

    if (status === 'reviewed' || status === 'final' || status === 'started' || status === 'completed') {
      return type === 'scorm' && registration_id ? openScorm() : openCourseProgress();
    }

    return register();
  };

  vm.evaluateProduct = function() {
    $uibModalStack.dismissAll();
    if (CoursesClass.isCourse(vm.event)) {
      return $state.go('app.courses.course.evaluation', {
        id: vm.event.course_id
      });
    }

    if (EventClass.isEvent(vm.event))
      $state.go('app.events.event.evaluation', {
        id: vm.event.event_id
      });
  };

  vm.unRegister = function() {
    vm.loading = true;
    ApiClass.eventsIdTypeTypeIdDelete({ id: vm.event.event_id, type: 'attendees', type_id: profile_uid })
      .then(() => {
        $log.debug('Attendee Deleted');
        vm.loading = false;
        vm.event.status = 'register';
        Swal.toast('User un-registration successful!');
        if (vm.registrationCallback) {
          vm.registrationCallback({ status: vm.event.status });
        }
      })
      .catch(error => $log.error(error));
  };

  vm.request = function() {
    vm.requestLoading = true;
    Swal.confirm('CPE Request', `Send registration request`)
      .then(() => {
        vm.requestLoading = true;

        let body;

        if (CoursesClass.isCourse(vm.event)) {
          body = { product: { course_id: vm.event.course_id, type: 'course' } };
        }

        if (EventClass.isEvent(vm.event)) {
          body = {
            product: { event_id: vm.event.event_id, type: 'event' },
            location: vm.event.delivery_location
          };
        }

        ApiClass.productsRequestsPut({}, body)
          .then(response => {
            $log.debug('cpe request sent', response);
            vm.requestLoading = false;
            vm.event.status = 'requested';
            vm.event.productRequest = response.data.item;
            Swal.toast('Registration Request Sent');
          })
          .catch(error => {
            vm.requestLoading = false;
            $log.error(error);
          });
      })
      .catch(error => {
        vm.requestLoading = false;
        if (error.dismiss || error === 'dismiss') return;
        $log.error(error);
        Swal.toast('Hold Up!, Somethings not quite right, please try again', 'error');
        throw error;
      });
  };

  vm.cancelRequest = event => {
    vm.cancelRequestLoading = true;

    Swal.confirm('Cancel Request', `Cancel the registration request for ${event.name || event.course_name}.`)
      .then(({ dismiss }) => {
        if (dismiss) {
          return Promise.reject('dismiss');
        }

        return ApiClass.productsRequestsIdDelete({ id: event.productRequest.uuid }, {});
      })
      .then(response => {
        Swal.toast('Request has been cancelled');
        vm.event.status = 'request';
        vm.cancelRequestLoading = false;
      })
      .catch(error => {
        vm.cancelRequestLoading = false;
        if (error.dismiss || error === 'dismiss') return;
        $log.error(error);
        Swal.toast('Hold Up!, Somethings not quite right, please try again', 'error');
        throw error;
      });
  };

  function register() {
    $uibModalStack.dismissAll();
    $uibModal
      .open({
        backdrop: true,
        size: 'lg',
        template,
        controller,
        controllerAs,
        resolve: {
          event: () => vm.event,
          bundle: () => false,
          adminRegistration: () => vm.adminRegistration,
          profileData: () => undefined,
          manage: () => false,
          loadContent: () => true
        }
      })
      .result.then(status => {
        if (CoursesClass.isCourse(vm.event)) {
          switch (status) {
            case 'registered':
            case 'userRegistered':
              vm.loading = true;
              Swal.toast('User registration successful!');
              // TODO: Timeout is here to wait for API to process. Need to get the status returned in the call.
              setTimeout(() => $state.go('app.courses.course', { id: vm.event.course_id }), 4500);
              break;
            case 'userAlreadyRegistered':
              Swal.toast('User already registered!', 'info');
              break;
            case 'userNotRegistered':
              Swal.toast('User registration failed!', 'error');
              break;
            case 'creditCardFailure':
              Swal.toast('User registration failed. Credit card was not processed.', 'error');
              break;
          }
        }

        if (EventClass.isEvent(vm.event)) {
          switch (status) {
            case 'registered':
            case 'userRegistered':
              vm.loading = true;
              Swal.toast('User registration successful!');
              // TODO: Timeout is here to wait for API to process. Need to get the status returned in the call.
              setTimeout(() => $state.go('app.events.event', { id: vm.event.event_id }), 3000);
              break;
            case 'userAlreadyRegistered':
              Swal.toast('User already registered!', 'info');
              break;
            case 'userNotRegistered':
              Swal.toast('User registration failed!', 'error');
              break;
            case 'creditCardFailure':
              Swal.toast('User registration failed. Credit card was not processed.', 'error');
              break;
            case 'full':
              const swalText =
                'This course is currently full and does not have a waitlist available.Please check again to see if a spot is available or contact the event organizer for assistance.';
              Swal.alert('', swalText, 'warning').then(() => $state.go('app.events.event', { id: vm.event.event_id }));
              vm.full = true;
              break;
            default:
              vm.event.status = status;
              Swal.toast(`You have been ${status} for the event.`);
          }
        }

        if (vm.event.type === 'scorm' && vm.event.course_id !== 'scorm' && !vm.event.event_id) {
          vm.loading = true;
          setTimeout(() => $state.go('app.courses.course', { id: vm.event.course_id }, { reload: true }), 3000);
        }

        if (vm.registrationCallback) {
          vm.registrationCallback({ status: vm.event.status });
        }
      })
      .catch(error => {
        if (error === 'cancel' || error === 'backdrop click') return;
        $log.error(error);
      });
  }

  function openScorm() {
    const urlRedirect = $location.url();
    const registration_id = vm.event.registration_id;
    const course_id = vm.event.course_id;
    const urlCallback = encodeURI(
      `${
        window.origin
      }/updateScorm?urlRedirect=${urlRedirect}&registration_id=${registration_id}&course_id=${course_id}`
    );
    ApiClass.coursesIdTypeTypeIdGet(
      { id: course_id, type: 'scorms', type_id: registration_id },
      {},
      { queryParams: { urlCallback } }
    )
      .then(({ data: { url } }) => {
        $window.location = url;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  function launchScorm() {
    const urlRedirect = $location.url();
    const registration_id = vm.event.registration_id;
    const event_id = vm.event.event_id;
    const urlCallback = encodeURI(
      `${window.origin}/updateScorm?urlRedirect=${urlRedirect}&registration_id=${registration_id}&event_id=${event_id}`
    );
    ApiClass.eventsIdTypeTypeIdGet(
      { id: event_id, type: 'scorms', type_id: registration_id },
      {},
      { queryParams: { urlCallback } }
    )
      .then(({ data: { url } }) => {
        $window.location = url;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  function openLink() {
    $window.open(vm.event.link);
  }

  function openCourseProgress() {
    $uibModalStack.dismissAll();
    if (CoursesClass.isCourse(vm.event)) {
      const progress = vm.event.progress || {};

      if (!progress.cert && progress.final) {
        return $state.go('app.users.courses.course.selfStudy.final', {
          id: profile_uid,
          courseId: vm.event.course_id
        });
      }

      $state.go('app.users.courses.course.selfStudy.video', {
        id: profile_uid,
        courseId: vm.event.course_id,
        moduleId: progress.next
      });
    }

    if (EventClass.isEvent(vm.event))
      $state.go('app.users.certificates', {
        id: profile_uid
      });
  }

  function activate() {
    if (!vm.event) {
      return;
    }

    vm.event = clone(vm.event);

    EventClass.setStatus(vm.event, vm.location);

    vm.selectedLocation = vm.event.delivery_location;

    if (vm.locationOverride) vm.event.defaultLocation = vm.locationOverride;

    const fourHourGap = new Date();
    fourHourGap.setHours(fourHourGap.getHours() - 4);

    const { waitlist, full } = EventClass.getWaitlist(vm.event, vm.locationOverride);
    const { expired } = CoursesClass.isExpired(vm.event);

    if (
      ['invitation', 'register', 'redeemed'].includes(vm.event.status) &&
      (new Date(vm.event.delivery_date).getTime() < fourHourGap.getTime() || vm.event.webinarFetched || expired)
    ) {
      vm.disable = true;
    }

    vm.waitlist = waitlist;
    vm.full = full;
    vm.expired = expired;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/marketplaceButton/controller.js